/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Feedback_RecordedInputs */



/**
* | output |
* | --- |
* | "Thanks for your feedback!" |
*
* @param {Chat_Feedback_RecordedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_feedback_recorded = /** @type {((inputs?: Chat_Feedback_RecordedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Feedback_RecordedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Danke für dein Feedback!")
	return /** @type {LocalizedString} */ ("Thanks for your feedback!")
});